import React from "react";
import { useRequest } from 'ahooks';
import { getPlmOverbudgetProjectsApi } from "@/services"
import { Table, TableProps, Card } from "antd"
import { IthHelmet, PpmProjectListRefreshEventName, ProjectStatus, ThEmpty, dispatchPpmProjectUpdateModalOpenEvent } from '@/components';
import { documentUtil } from "@/utils"
import { generatePath } from "react-router-dom"

const Index = () => {
    const { data, loading } = useRequest(getPlmOverbudgetProjectsApi)
    const tableColumns: TableProps<API.PROJECT.OverviewProject>['columns'] = [
        {
            key: 'name',
            dataIndex: 'name',
            title: '预算超支项目',
            width: 300,
            showSorterTooltip: false,
            className: 'group-hover:bg-inherit',
            render: (text, record) => {
                return (
                    <div>
                        <a
                            href={generatePath("/projects/:projectID/costs", { projectID: record.id.toString() })}
                            target="_blank"
                            className="text-base font-medium text-gray-600 hover:font-bold hover:text-gray-800 hover:underline two-line-clamp"
                        >
                            {text}
                        </a>
                    </div>
                )
            }
        }
    ];
    return (
        <Card>
            <Table
                loading={loading}
                tableLayout="fixed"
                rowKey="code"
                columns={tableColumns}
                dataSource={data || []}
                pagination={false}
                rowClassName="even:bg-gray-50 odd:bg-white hover:shadow-eq hover:scale-100 transition-shadow duration-300 group"
                locale={{
                    emptyText: (
                        <ThEmpty
                            description={(
                                <div className="text-black/50 mt-4">
                                    暂无预算超支项目
                                </div>
                            )}
                        />
                    ),
                }}
            />
        </Card>
    )
}
export default Index